"use client";
import { useI18n } from "@/lib/i18n";

import Link from "next/link";
import { useState } from "react";
import { useNotificationContext } from "./NotificationProvider";


export default function NotificationBell() {
  const { t, locale } = useI18n();
  const { items, unreadCount, markRead, markAllRead } = useNotificationContext();
  const [open, setOpen] = useState(false);

  return (
    <div className="relative">
    <button onClick={() => setOpen((value) => !value)} className="relative inline-flex items-center justify-center rounded-lg p-2 text-gray-300 hover:bg-neutral-800" aria-label={t("user.notifications")} title={t("user.notifications")}>
      {/* Bell Icon */}
      <svg
        className="w-6 h-6"
        fill="none"
        stroke="currentColor"
        strokeWidth={2}
        viewBox="0 0 24 24"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M15 17h5l-1.405-1.405A2.032 2.032 0 0 1 18 14.158V11a6 6 0 1 0-12 0v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0a3 3 0 0 1-6 0m6 0H9"
        />
      </svg>

      {/* Badge */}
      {unreadCount > 0 && (
        <span className="absolute -top-1 -right-1 min-w-[18px] h-[18px] px-1 rounded-full bg-red-600 text-white text-[11px] leading-[18px] text-center">
          {unreadCount > 99 ? "99+" : unreadCount}
        </span>
      )}
    </button>
    {open && <div className="absolute right-0 top-12 z-50 w-96 max-w-[calc(100vw-2rem)] rounded-xl border border-slate-700 bg-slate-950 p-3 shadow-2xl">
      <div className="flex items-center justify-between border-b border-slate-800 pb-3">
        <span className="font-semibold">{t("user.notifications")}</span>
        {unreadCount > 0 && <button onClick={markAllRead} className="text-xs text-cyan-300 hover:text-cyan-200">{t("notifications.allRead")}</button>}
      </div>
      <div className="max-h-80 overflow-y-auto py-2">
        {items.length === 0 ? <p className="px-2 py-6 text-center text-sm text-slate-500">{t("notifications.empty")}</p> : items.map((item) => <button key={item.id} onClick={() => markRead(item.id)} className="block w-full rounded-lg px-2 py-3 text-left hover:bg-slate-900">
          <div className="flex items-start gap-2"><span className={`mt-1 h-2 w-2 shrink-0 rounded-full ${item.severity === "critical" || item.severity === "error" ? "bg-red-400" : "bg-cyan-400"}`} /><span className="min-w-0"><span className="block font-medium text-slate-100">{item.title}</span><span className="mt-1 block text-sm text-slate-400">{item.message}</span></span></div>
        </button>)}
      </div>
      <Link href="/settings/notifications" onClick={() => setOpen(false)} className="mt-2 block border-t border-slate-800 pt-3 text-center text-sm text-cyan-300 hover:text-cyan-200">{t("notifications.open")}</Link>
    </div>}
    </div>
  );
}
